const themePacks = [
  {
    id: 'wedding-morning',
    title: 'Wedding Morning Pack',
    alt: 'Wedding Morning Pack',
    img: 'https://lh3.googleusercontent.com/aida-public/AB6AXuA9YnIeBTKJPEXiOVggDRTWJlo8dPO6CNZdwuX-PuC05akYpwQZvktvOLlxCoP2KoNDu0VGedes6qeK79Sb-Wzvl0zen0OrDsafKUX2ztClZJ9NNkpS9KyC9f0JsuWZj6NNY5bmNu0pXhHSswuhcGL5J84LtGo-6xsALRGWKlW5hTb9LIWv7GuuZMahPFbtl3zH0wu2_Y2AaKBSOOGwu23DJ2zhRMxkYE3GGdPiDEjhV9yiqrVosjyqHrUxRZ5q5FuHf0xavOeJdD9X',
    tagIcon: 'wb_sunny',
    tagText: 'Morning Fresh',
    description: 'Start your big day with curated ritual floral essentials.',
    features: ['2 Garlands + 5kg Loose Flowers', 'Premium Car Floral Decor'],
    price: '₹14,999',
  },
  {
    id: 'house-pooja',
    title: 'House Pooja Pack',
    alt: 'House Pooja Pack',
    img: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDvwkOlkrqf9ahhKQwDNjef1iNAZfIKl-MNcWBAQL4R2MNYpQpV9jCl6DbZW2Zt4eCPL6UzOxuOP2QBE2-sTpALQAAyeHnlBwLvThHGtpseprcolEreLxkw97st4rB_RkzGUg5cntPOu8ZjSMStYYnlhXhznCHuyd0b3oz81uWXTztaTU9WYeYWVJxLjKvH_KrqS9rnaVxzfzWPuGE8l4OXOSm3RMg34hPBimbWme2cdI3tpnewlOGd36cXl6Ea0q1HefEEUol0fzzn',
    tagIcon: 'home',
    tagText: 'Home Essential',
    description: 'Complete sacred flower set for Grah Pravesh or daily ritual.',
    features: ['Toran + Door Hangings', '5 Assorted Flower Varieties'],
    price: '₹2,499',
  },
  {
    id: 'birthday-surprise',
    title: 'Birthday Surprise Pack',
    alt: 'Birthday Surprise Pack',
    img: 'https://lh3.googleusercontent.com/aida-public/AB6AXuA1qICqM-Pj4N7xxxUNbfhJ5PRtdAg4Lgzias5Lj0TZIol1YOUfOZ3Ks-fRMvjH5JMQSLCSZi3LRO-IFWHxO3VliZvf2usDB2C3d3RjEYgZ68BfuPBkvuN5y2lhRZfaexFyugo20Zo7jgjUb55jmN_37Mk-f4Kr9S6-spGnD0zYheMrRP6-E47xrepwVJjpVj067YFolRLK598tyyD5l5u9k9VEcizdq6O2zpSByxInojdSZPE3b0FBSN23v7C1v9hf9NWEoIrOBeSp',
    tagIcon: 'cake',
    tagText: 'Celebration',
    description: 'Hand-picked exotic blooms for a memorable doorstep surprise.',
    features: ['100 Premium Red Roses', 'Room Petal Decor Service'],
    price: '₹5,999',
  },
  {
    id: 'temple-offering',
    title: 'Temple Offering Pack',
    alt: 'Temple Offering Pack',
    img: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDlkOcuvaCEnUjLOtaZVa07aXctYQTrus_gE6jIyrt0aYEgnIXKgobb9bR7fgEpzeiT-YCPl_VU5qSsfgnqOhdTkTNpn9QAEIQLWR0l-7haT8SXTs9OF1kpZ39RcedIl6se46zl5lF-p6A-SYdFinceUV_BvzoZuDcaPTVPkIObGP5NcCF9BZCny07j462WhdgS_TJB2GmxhhG8xxkqFjsjuJqdyIb49MiKdb0u-aD0anhj9EmPm6UHbpW1g3pw886Dh3_GZnAcVYgq',
    tagIcon: 'temple_hindu',
    tagText: 'Devotional',
    description: 'Curated set of sacred flowers for temple visits and offerings.',
    features: ['10 Pink Lotuses + Marigold', 'Traditional Banana Leaves'],
    price: '₹1,299',
  },
];

export default themePacks;
